import { render, staticRenderFns } from "./Issues.vue?vue&type=template&id=f53f9a7a"
import script from "./Issues.vue?vue&type=script&lang=js"
export * from "./Issues.vue?vue&type=script&lang=js"
import style0 from "./Issues.vue?vue&type=style&index=0&id=f53f9a7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports